import { LeadForm } from "@modules/lead/components";
import React from "react";
import styles from "./form.module.scss";

const pageData = {
  dynamicDescription: "",
  pageTitle: "<p>Study Abroad Consultants in Bangalore</p>",
  pageName: "Study Abroad Consultants in Bangalore",
  metaTitle: null,
  metaDescription: null,
  metaKeywords: null,
  template: "default",
  pageContent: {
    eventDate: "Invalid date",
    startTime: null,
    endTime: null,
    featuresSection: [
      {
        featureSubtitle: "",
        featureTitle: "",
        featuresCard: [
          {
            cardColor: "#4A2ED7",
          },
        ],
      },
    ],
  },
  featureImageSrc: null,
  formTitle: "Want to study abroad? Sign up with UniSearch!",
  formDescription: "Just fill in your details and we’ll call you back.",
  formNote: "",
  formSchema: [
    {
      name: "name",
      label: "Full Name",
      type: "text",
      isRequired: 1,
      columnSize: "6",
      placeholder: "Enter your full name",
      sortNo: 0,
      options: [
        {
          label: "",
          value: "",
        },
      ],
    },
    {
      name: "email",
      label: "Email Address",
      type: "email",
      isRequired: 1,
      columnSize: "6",
      placeholder: "Enter your email",
      sortNo: 1,
      options: [
        {
          label: "",
          value: "",
        },
      ],
    },
    {
      name: "phone",
      label: "Phone Number",
      type: "number",
      isRequired: 1,
      columnSize: "6",
      placeholder: "Enter your phone number",
      sortNo: 2,
      options: [
        {
          label: "",
          value: "",
        },
      ],
    },
    {
      name: "country",
      label: "Preferred Country",
      type: "country",
      isRequired: 1,
      columnSize: "6",
      placeholder: "",
      sortNo: 3,
      options: [
        {
          label: "Australia",
          value: "Australia",
        },
        {
          label: "Canada",
          value: "Canada",
        },
        {
          label: "Ireland",
          value: "Ireland",
        },
        {
          label: "New Zealand",
          value: "New Zealand",
        },
        {
          label: "United Kingdom",
          value: "United Kingdom",
        },
        {
          label: "United States",
          value: "United States",
        },
      ],
    },
  ],
};

export const EventForm = () => {
  return (
    <section>
      <div className="container">
        <div className={styles.form_wrapper}>
          <LeadForm pageSlug="temp" pageData={pageData} />
        </div>
      </div>
    </section>
  );
};

export default EventForm;
